<div class="confirmation-dialog dialog">
  <div class="dialog-header">
    <h5>{{ dialogData.title }}</h5>
    <span class="dialog-close" (click)="close()" (keypress)="close()">
      <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false" />
    </span>
  </div>
  <mat-dialog-content class="confirmation-dialog-content dialog-content">
    <div class="confirmation-dialog-content-message">{{ dialogData.message }}</div>
    <div class="confirmation-dialog-content-button">
      <div class="confirmation-dialog-content-button-separator"></div>
      @if (data.cancelButtonText) {
        <button (click)="close()" class="confirmation-dialog-content-button-cancel">
          {{ dialogData.cancelButtonText }}
        </button>
      }
      <button (click)="close(true)" class="confirmation-dialog-content-button-save">
        {{ dialogData.buttonText }}
      </button>
    </div>
  </mat-dialog-content>
</div>